// 法语
export default {
  home: {
    minute: 'minute',
    price_info: '{mianfei} minutes gratuits, maximum par jour {currencyName}{fengding}, dépôt {currencyName}{yajin}, dépôt de location gratuit',
    feature_1: 'Conception spéciale pour la recharge sans fil',
    feature_2: 'Emprunt et remboursement universels nationaux',
    feature_3: 'Quatre modes de charge, adaptés à tous les téléphones portables',
    submit: 'Recharger',
    borrow: 'Emprunter',
    inputcodetitle: 'Veuillez entrer le numéro de l\'appareil sur le placard',
    msg_rentcount: 'Vous avez actuellement {zujieNum} commandes qui ne sont pas fermées',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    msg_fail_title: 'Erreur',
    msg_fail_content: 'La location a échoué, veuillez réessayer',
    shoptime: 'Heure d\'ouverture',
    supportrental: 'Soutien à la location',
    supportreturn: 'Soutien au retour',
    useragreen: 'Cliquez pour accepter le \'Formulaire d\'autorisation de débit délégué Contrat d\'utilisateur Contrat de recharge',
    privacyagreen: 'Cliquez pour accepter l\'accord de confidentialité',
    offline: 'L\'appareil {devicecode} est hors ligne, veuillez contacter le personnel présent',
    permissionfail: 'Autorisation refusée.',
    unbound: 'Le code QR Mix {devicecode} n\'est pas lié à l\'appareil',
    nobattery: 'Aucune batterie disponible dans l\'appareil {devicecode}',
    gomap: 'Voir les station à proximité'
  },
  loginborrow: {
    powerbanktitle: 'Débloquez votre banque moovenergypower',
    loginwith: 'Accedi con',
    msg_fail_title: 'Erreur',
    msg_fail_user: 'Erreur lors de l\'obtention des informations utilisateur. Voulez-vous réessayer ?',
    msg_rentcount: 'Vous avez actuellement {zujieNum} commandes qui ne sont pas fermées',
    msg_fail_support: 'Le système n\'est pas pris en charge',
    msg_fail_confirm: 'Confirmer',
    msg_fail_retry: 'Réessayer',
    msg_fail_cancel: 'Annuler',
    msg_fail_order: 'Échec de la création de la commande de location',
    msg_fail_paymod: 'Échec de l\'obtention du mode de paiement',
    msg_fail_login: 'Échec de la connexion',
    Apple: 'Apple',
    otheropt: 'Autres options',
    selectmethod: 'Sélectionnez votre mode de paiement',
    paymentdetail: 'Détails du mode de paiement',
    couponcode: 'Code promo',
    rent: 'Confirmer le paiement',
    pricing: 'Voir les prix',
    phone: 'Téléphone',
    Google: 'Google',
    Facebook: 'Facebook',
    loginfb: 'Se connecter avec Facebook',
    logingg: 'Se connecter avec Google',
    captcha_code: 'Code',
    phonenumber: 'Entrez votre numéro de téléphone portable ',
    msg_fail_code: 'Veuillez entrer le code de vérification',
    msg_fail_phone: 'Veuillez entrer votre numéro de téléphone',
    logout: 'Quitter le compte',
    savenow: 'Économisez maintenant',
    delete: 'Supprimer',
    addcard: 'Entrez les détails de la carte',
    msg_fail_content: 'La location a échoué, veuillez réessayer',
    title: 'Veuillez confirmer l\'autorisation',
    policy: 'Politique.',
    term: ' Conditions générales d\'utilisation',
    and: 'et',
    privacy: 'Politique de confidentialité.',
    tips: 'En continuant, vous acceptez notre ',
    cancel: 'ANNULER',
    agree: 'ACCEPTER',
    openinbrowser: 'Veuillez ouvrir dans votre navigateur',
    localtip1: 'Renvoyer la batterie à n\'importe quelle station moov Energy',
    localtip2: 'Pour trouver une station à proximité, consultez la carte ou Scannez le QR sur la Banque de charge.'
  },
  preauth: {
    preauthortitle: 'À propos de la pré-autorisation',
    tip1: 'Lorsque vous commencez une location, une pré-autorisation est placée sur votre mode de paiement. Cela permet simplement de s\'assurer qu\'il y a suffisamment de fonds disponibles pour payer votre location.',
    tip2: 'Votre banque peut vous envoyer une notification mais il ne s\'agit pas d\'un prélèvement : seul le prix de votre location sera facturé.',
    tip3: 'Selon votre banque, il peut s\'écouler quelques heures à quelques jours avant que le montant ne soit ajusté sur vos relevés, c\'est normal.'
  },
  rentcost: {
    rentcosttitle: 'Combien coûte la location ?',
    tip1: 'Si vous ne retournez pas la batterie externe dans les 48 heures, vous serez facturé des frais de non-retour de {currency} {yajin} .',
    tip2: 'La durée est arrondie à la demi-heure la plus proche (30 ou 60 minutes).',
    tip3: 'Une location d\'une journée est de 24 heures à partir du moment où la batterie externe est louée.',
    tip4: 'Certains lieux peuvent offrir des heures gratuites ou des réductions. Profitez-en !',
    Days: 'Jours',
    Hours: 'Heures',
    Minutes: 'Minutes'
  },
  logincode: {
    login: 'Connexion',
    retry: 'Renvoyer'
  },
  agreenconfirm: {
    title: 'Veuillez confirmer l\'autorisation',
    policy: 'Politique.',
    term: 'Conditions générales d\'utilisation de MoovEnergy',
    and: 'et',
    privacy: 'Politique de confidentialité.',
    tips: 'Je suis d\'accord avec ',
    cancel: 'ANNULER',
    agree: 'ACCEPTER'
  },
  login: {
    phonenumber: 'Numéro de téléphone',
    verificationcode: 'Code de vérification',
    Rentpowerbank: 'Louer une batterie externe',
    Rentpowerbanktip: 'Entrez votre numéro de téléphone portable pour commencer',
    phone_number: 'Veuillez entrer un numéro de téléphone portable à {0} chiffres ',
    captcha_code: 'Code',
    send_code: 'Envoyer le code',
    login: 'Connexion',
    agree: 'En cliquant sur Connexion, vous acceptez ',
    readme: `Contrat d'utilisateur`,
    msg_fail_login: 'Échec de la connexion',
    msg_success_login: 'Connexion réussie',
    msg_success_login_code: 'Reçu avec succès, veuillez télécharger l\'APP pour vous connecter et utiliser',
    msg_fail_user: 'Erreur lors de l\'obtention des informations utilisateur. Voulez-vous réessayer ?',
    no_sms: 'Pas de message texte reçu',
    retry: 'Renvoyer',
    receive: 'Postuler',
    invite_pwd: 'Code d\'invitation',
    vip_agreen_tip: 'En continuant, vous indiquez que vous acceptez notre',
    vip_agreen_service: 'Conditions d\'utilisation',
    vip_agreen_and: 'et',
    vip_agreen_policy: 'Politique de confidentialité'
  },
  map: {
    free: 'Peut être emprunté',
    return: 'Peut également'
  },
  msg: {
    appnolaunched: 'L’app n’est pas encore officiellement en rayon',
    none_code: 'Le code n\'existe pas',
    sms_fail: 'Échec de l\'envoi du SMS',
    unlogin: 'Vous ne vous êtes pas encore connecté, veuillez vous connecter',
    msg_fail_title: 'Avertissement',
    deletecard: 'Êtes-vous sûr de vouloir supprimer cette carte ?',
    loading: 'Chargement...',
    title: 'Conseils',
    success: 'Opération réussie',
    error: 'Erreur inconnue, veuillez réessayer plus tard.',
    roleerror: 'Permissions insuffisantes, veuillez consulter l\'administrateur',
    neterror: 'Échec de la connexion au réseau. Veuillez réessayer plus tard',
    confirm: 'Confirmer',
    retry: 'Réessayer',
    cancel: 'Annuler',
    msg_logout: 'Êtes-vous sûr de vouloir quitter le compte ?',
    vieworder: 'Voir la commande',
    addorselectcard: 'Veuillez ajouter ou sélectionner un forfait carte pour continuer',
    success_payment: 'Paiement effectué',
    fail_payment: 'Échec du paiement',
    keyword: 'mot-clé',
    unpaid_order: 'Il y a des commandes impayées',
    go_pay: 'Aller payer',
    no_more: 'plus rien',
    noshop: 'Pas de marchands',
    msg_fail_code: 'Veuillez entrer le code de vérification',
    msg_fail_phone: 'Veuillez entrer votre numéro de téléphone',
    exceedorder: 'Vous avez déjà une commande en cours de location, veuillez la retourner avant de continuer'
  },
  result: {
    title: 'Location confirmée',
    tips: 'Pour voir les commandes et les autres emplacements MoovEnergy, veuillez télécharger l\'application.',
    download: 'TÉLÉCHARGER',
    msg_result_loading: 'Le résultat du paiement est en cours de confirmation...',
    msg_tips_loading: 'La batterie portable est en train de sortir, veuillez patienter...'
  },
  result_msg: {
    loading: 'Chargement...',
    refresh: 'Actualiser'
  },
  nearby: {
    rent: 'Peut être emprunté',
    return: 'Peut également',
    here: 'Allez ici'
  }
}
